module.exports = __webpack_public_path__ + "static/img/trade3.737e7a10.png";